import React, { useEffect, useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HeaderDashboard from '../../components/HeaderDashboard';
import { useNavigate } from 'react-router-dom';
import { Button, Chip, Switch, Collapse, Divider, LinearProgress } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box, Typography } from "@mui/material";
import { useUser } from '../../../contexts/UserContext';
import { MascaraCpf } from '../../../utils/MascaraCpf';
import { MascaraCnpj } from '../../../utils/MascaraCnpj';
import { MascaraTelefone } from '../../../utils/MascaraTelefone';
import axios from 'axios';
import { TirarMascara } from '../../../utils/TirarMascara';
import { MascaraCep } from '../../../utils/MascaraCep';
import Loading from '../../components/Loading';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { NumericFormat } from 'react-number-format';
import AlertError from '../../components/AlertError';
import ReceiptIcon from '@mui/icons-material/Receipt';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs, Link } from "@mui/material";
import AlertSuccess from '../../components/AlertSuccess';
import BusinessIcon from '@mui/icons-material/Business';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const estados = [
    "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
    "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
    "RS", "RO", "RR", "SC", "SP", "SE", "TO"
];

const arredondar = (numero) => Math.round((Number.isFinite(numero) ? numero : 0) * 100) / 100;

const somenteDigitos = (valor) => String(valor ?? "").replace(/\D/g, "");

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const campoSx = {
    "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff" },
};

const linhaCamposSx = (colunas) => ({
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: colunas },
    gap: 1.5,
});

// Definido fora do componente para não remontar os inputs (e perder o foco) a cada render
const SecaoCard = ({ icone, titulo, descricao, acao, children }) => (
    <Box sx={cardSx}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap", mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "8px",
                        backgroundColor: "#f3f4f6",
                        color: "#374151",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        "& svg": { fontSize: 20 },
                    }}
                >
                    {icone}
                </Box>
                <Box>
                    <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>{titulo}</Typography>
                    <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{descricao}</Typography>
                </Box>
            </Box>
            {acao}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>{children}</Box>
    </Box>
);

const LinhaResumo = ({ label, valor, destaque }) => (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 1 }}>
        <Typography sx={{ fontSize: 13, color: "#cbd5e1" }}>{label}</Typography>
        <Typography sx={{ fontSize: destaque ? 20 : 13, fontWeight: destaque ? 700 : 600, color: destaque ? "#ffc845" : "#fff", textAlign: "right" }}>
            {valor}
        </Typography>
    </Box>
);

const hoje = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const moeda = (numero) => (Number.isFinite(numero) ? numero : 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

// Mensagem de erro do backend de emissão ({ status: 400, error }) com os formatos antigos como reserva
const mensagemErroApi = (dados) => dados?.error || dados?.mensagem || dados?.message || dados?.erro || "";

const EmitirNotaServico = () => {
    const { user, fetchUser } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [notificacoes, setNotificacoes] = useState([]);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [hasTomador, setHasTomador] = useState(true);
    const [servicos, setServicos] = useState([]);

    const [cpfCnpjTomador, setCpfCnpjTomador] = useState('');
    const [razaoSocialTomador, setRazaoSocialTomador] = useState('');
    const [emailTomador, setEmailTomador] = useState('');
    const [telefoneTomador, setTelefoneTomador] = useState('');
    const [cepTomador, setCepTomador] = useState('');
    const [enderecoTomador, setEnderecoTomador] = useState('');
    const [numeroTomador, setNumeroTomador] = useState('');
    const [estadoTomador, setEstadoTomador] = useState('');
    const [cidadeTomador, setCidadeTomador] = useState('');
    const [bairroTomador, setBairroTomador] = useState('');
    const [codigoIbgeTomador, setCodigoIbgeTomador] = useState('');
    const [servicoSelecionado, setServicoSelecionado] = useState(null);
    const [descricaoServico, setDescricaoServico] = useState('');
    const [valorServico, setValorServico] = useState('');
    const [aliquota, setAliquota] = useState('0');

    const [mostrarAvancadas, setMostrarAvancadas] = useState(false);
    const [dataCompetencia, setDataCompetencia] = useState(hoje());
    const [reterIr, setReterIr] = useState(false);
    const [valorIrRetido, setValorIrRetido] = useState('');

    const [emitindo, setEmitindo] = useState(false);

    const [open, setOpen] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);


    useEffect(() => {
        if (servicos.length === 0) {
            fetchUser();
        }
        setServicos(user?.servicos || []);
    }, [user]);

    const mostrarErro = (texto) => {
        setMensagem(texto);
        setOpenSnackbarError(true);
    };

    // A Spedy identifica a cidade do tomador pelo código IBGE, que o ViaCEP devolve junto com o endereço
    const buscarCep = async (cep, manterEnderecoPreenchido = false) => {
        const somenteNumeros = TirarMascara(cep);
        if (somenteNumeros.length !== 8) return;

        try {
            const { data } = await axios.get(`https://viacep.com.br/ws/${somenteNumeros}/json/`);
            if (!data || data.erro) {
                setCodigoIbgeTomador('');
                return;
            }

            setCodigoIbgeTomador(data.ibge || '');
            const preencher = (setter, valor) => {
                if (valor) setter((atual) => (manterEnderecoPreenchido && atual ? atual : valor));
            };
            preencher(setEnderecoTomador, data.logradouro);
            preencher(setBairroTomador, data.bairro);
            preencher(setCidadeTomador, data.localidade);
            preencher(setEstadoTomador, data.uf);
        } catch (error) {
            console.error("Erro ao buscar CEP:", error?.response || error);
            setCodigoIbgeTomador('');
        }
    };

    const handleCepTomador = (value) => {
        const cepFormatado = MascaraCep(value);
        setCepTomador(cepFormatado);
        if (TirarMascara(cepFormatado).length === 8) {
            buscarCep(cepFormatado);
        } else {
            setCodigoIbgeTomador('');
        }
    };

    const handleCpfCnpjTomador = async (value) => {
        if (!value) return;

        const somenteNumeros = value.replace(/\D/g, "");

        // CPF
        if (somenteNumeros.length <= 11) {
            setCpfCnpjTomador(MascaraCpf(value));
            return;
        }

        // CNPJ
        const cnpjFormatado = MascaraCnpj(value);
        setCpfCnpjTomador(cnpjFormatado);

        // Só busca quando CNPJ estiver completo
        if (somenteNumeros.length !== 14) return;

        try {
            setOpen(true);

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/buscarCnpj/${somenteNumeros}`,
                {
                    headers: {
                        "Authorization": localStorage.getItem("token"),
                    },
                }
            );

            const data = response?.data.data;

            if (!data) {
                mostrarErro("CNPJ não encontrado.");
                return;
            }

            const endereco = data?.endereco || {};

            setRazaoSocialTomador(data.razao_social ?? "");
            setEmailTomador(data.email ?? "");
            setCepTomador(MascaraCep(endereco.cep ?? ""));
            setEnderecoTomador(endereco.logradouro ?? "");
            setNumeroTomador(endereco.numero ?? "");
            setBairroTomador(endereco.bairro ?? "");
            setCidadeTomador(endereco.municipio ?? "");
            setEstadoTomador(endereco.uf ?? "");
            await buscarCep(endereco.cep ?? "", true);

        } catch (error) {
            console.error("Erro ao buscar CNPJ:", error?.response || error);
            mostrarErro("Erro ao buscar CNPJ. Verifique o número ou tente novamente mais tarde.");
        } finally {
            setOpen(false);
        }
    };

    const formatarValor = (valor) => {
        return Number(String(valor || "").replace("R$ ", "").replace(/\./g, "").replace(",", ".")) || 0;
    };

    // Valores calculados usados no resumo e no corpo da emissão
    const valorBruto = arredondar(formatarValor(valorServico));
    const valorIr = reterIr ? arredondar(formatarValor(valorIrRetido)) : 0;
    const valorLiquido = arredondar(valorBruto - valorIr);
    const aliquotaSimples = parseFloat(String(aliquota || "0").replace(',', '.')) || 0;

    // Emissão liberada só com empresa integrada à Spedy, certificado válido e saldo no plano
    const certificado = user?.certificado || null;
    const certificadoVencido = !!certificado?.validade && new Date(certificado.validade) < new Date();
    const limitePlano = user?.plano?.qtdNfseMensalUsuario;
    const notasEmitidas = Number(user?.notasEmitidasEsteMes) || 0;
    const ilimitado = limitePlano === -1;
    const planoSemEmissao = !ilimitado && !(limitePlano > 0);
    const limiteAtingido = !ilimitado && !planoSemEmissao && notasEmitidas >= limitePlano;
    const porcentagemLimite = limitePlano > 0 ? Math.min((notasEmitidas / limitePlano) * 100, 100) : 0;

    const bloqueio =
        !user ? null :
            !user.empresa || !user.empresa.emissaoConfigurada
                ? { texto: "Sua empresa ainda está sendo configurada pela equipe Clarea para a emissão de notas fiscais." }
                : !certificado || !certificado.validade
                    ? { texto: "Seu certificado digital ainda não foi enviado. Envie o certificado A1 para liberar a emissão de notas.", acao: "Enviar certificado", rota: "../Dashboard/Certificado" }
                    : certificadoVencido
                        ? { texto: "Seu certificado digital está vencido. Envie o certificado renovado para continuar emitindo notas.", acao: "Atualizar certificado", rota: "../Dashboard/Certificado" }
                        : planoSemEmissao
                            ? { texto: "Seu plano atual não possui emissão de notas fiscais.", acao: user.secretaria ? null : "Ver planos", rota: "../Dashboard/MudarPlano" }
                            : limiteAtingido
                                ? { texto: `Você atingiu o limite de ${limitePlano} ${limitePlano === 1 ? "nota fiscal" : "notas fiscais"} do seu plano neste mês.`, acao: user.secretaria ? null : "Ver planos", rota: "../Dashboard/MudarPlano" }
                                : null;

    // O Emissor Nacional exige o código NBS do serviço
    const servicoSemNbs = !!servicoSelecionado && !somenteDigitos(servicoSelecionado.codigoNbs);

    // Corpo no formato do POST /emitirNotaServico (mesma lógica de emissão da Contblack)
    const montarCorpoEmissao = () => ({
        dataCompetencia: `${dataCompetencia}T12:00:00-03:00`,
        codigo: servicoSelecionado.codigo,
        descricaoDoServico: descricaoServico.trim(),
        total: {
            valorServico: valorBruto,
            valorLiquido,
            reterIr,
            valorIrRetido: valorIr,
        },
        hasTomador,
        tomador: hasTomador ? {
            name: razaoSocialTomador.trim(),
            federalTaxNumber: TirarMascara(cpfCnpjTomador),
            email: emailTomador.trim() || null,
            phoneNumber: TirarMascara(telefoneTomador) || null,
            address: {
                street: enderecoTomador || null,
                district: bairroTomador || null,
                postalCode: TirarMascara(cepTomador) || null,
                number: numeroTomador || null,
                city: {
                    name: cidadeTomador || null,
                    state: estadoTomador ? estadoTomador.toLowerCase() : null,
                    code: codigoIbgeTomador ? Number(codigoIbgeTomador) : null,
                },
                country: "BRA",
            },
        } : null,
        approximateTaxes: { simplesNacionalRate: aliquotaSimples },
    });

    const limparFormulario = () => {
        setAliquota('0');
        setServicoSelecionado(null);
        setDescricaoServico('');
        setValorServico('');
        setDataCompetencia(hoje());
        setReterIr(false);
        setValorIrRetido('');
        setCpfCnpjTomador('');
        setRazaoSocialTomador('');
        setEmailTomador('');
        setTelefoneTomador('');
        setCepTomador('');
        setEnderecoTomador('');
        setNumeroTomador('');
        setEstadoTomador('');
        setCidadeTomador('');
        setBairroTomador('');
        setCodigoIbgeTomador('');
    };

    const handleEmitirNota = async () => {
        if (emitindo) return;

        if (bloqueio) {
            mostrarErro(bloqueio.texto);
            return;
        }

        if (!servicoSelecionado) {
            mostrarErro('Por favor, selecione o serviço prestado.');
            return;
        }

        if (servicoSemNbs) {
            mostrarErro('O serviço selecionado não tem código NBS (obrigatório no Emissor Nacional). Cadastre o NBS do serviço antes de emitir.');
            return;
        }

        if (!descricaoServico.trim()) {
            mostrarErro('Por favor, informe a descrição do serviço.');
            return;
        }

        if (valorBruto <= 0) {
            mostrarErro('Por favor, insira um valor válido para o serviço.');
            return;
        }

        if (reterIr && (valorIr <= 0 || valorIr > valorBruto)) {
            mostrarErro('Informe um valor de IR retido maior que zero e menor que o valor do serviço.');
            return;
        }

        if (!dataCompetencia || Number.isNaN(new Date(`${dataCompetencia}T12:00:00`).getTime())) {
            mostrarErro('Por favor, informe uma data de competência válida.');
            return;
        }

        if (hasTomador) {
            const documento = TirarMascara(cpfCnpjTomador);
            if (!razaoSocialTomador.trim() || (documento.length !== 11 && documento.length !== 14)) {
                mostrarErro('Por favor, informe um CPF/CNPJ válido e o nome do tomador.');
                return;
            }
        }

        setEmitindo(true);
        setOpen(true);

        try {
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/emitirNotaServico`, montarCorpoEmissao(), {
                headers: {
                    Authorization: localStorage.getItem('token'),
                    'Content-Type': 'application/json'
                }
            });

            if (data.status !== 200) {
                mostrarErro(mensagemErroApi(data) || 'Erro ao emitir nota fiscal. Verifique os dados e tente novamente.');
                return;
            }

            // A emissão é assíncrona: a prefeitura autoriza ou rejeita em seguida
            setMensagem('Nota fiscal enviada para emissão! Acompanhe o status em "Notas fiscais emitidas".');
            setOpenSnackbarSuccess(true);
            limparFormulario();
            fetchUser();
        } catch (error) {
            console.error("Erro ao emitir nota fiscal:", error?.response || error);
            mostrarErro(mensagemErroApi(error?.response?.data) || 'Erro ao emitir nota fiscal. Tente novamente mais tarde.');
        } finally {
            setEmitindo(false);
            setOpen(false);
        }
    };

    const handleChange = (event) => {
        setEstadoTomador(event.target.value);
    };

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <ReceiptIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Emitir NFS-e
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Emitir Nota Fiscal de Serviço
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Preencha os dados do tomador e do serviço prestado. Confira o resumo antes de emitir.
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: { xs: "stretch", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: 1.5 }}>
                        <Box sx={{ backgroundColor: "#f3f4f6", borderRadius: "10px", px: 1.5, py: 1, minWidth: 180 }}>
                            <Typography sx={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase", letterSpacing: 0.6 }}>Notas neste mês</Typography>
                            <Typography sx={{ fontSize: 16, fontWeight: 700, color: limiteAtingido ? "#b45309" : "#111827" }}>
                                {notasEmitidas}
                                <Box component="span" sx={{ fontSize: 13, fontWeight: 500, color: "#6b7280" }}>
                                    {" / "}{ilimitado ? "Ilimitadas" : limitePlano ?? 0}
                                </Box>
                            </Typography>
                            {!ilimitado && (
                                <LinearProgress
                                    variant="determinate"
                                    value={porcentagemLimite}
                                    sx={{ mt: 0.5, height: 5, borderRadius: 3, backgroundColor: "#e5e7eb", "& .MuiLinearProgress-bar": { backgroundColor: limiteAtingido ? "#d97706" : "#0b243d", borderRadius: 3 } }}
                                />
                            )}
                        </Box>
                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate("../Dashboard")}
                            sx={{ alignSelf: { xs: "flex-start", sm: "center" }, textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                        >
                            Voltar
                        </Button>
                    </Box>
                </Box>

                {bloqueio && (
                    <Box sx={{ mt: 2, display: "flex", alignItems: { xs: "stretch", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, justifyContent: "space-between", gap: 1.5, backgroundColor: "#fef3c7", border: "1px solid #fde68a", borderRadius: "12px", px: 2, py: 1.5, color: "#b45309" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <WarningAmberIcon sx={{ fontSize: 20 }} />
                            <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{bloqueio.texto}</Typography>
                        </Box>
                        {bloqueio.acao && (
                            <Button
                                onClick={() => navigate(bloqueio.rota)}
                                sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", px: 2, whiteSpace: "nowrap", "&:hover": { backgroundColor: "#f5b82e" } }}
                            >
                                {bloqueio.acao}
                            </Button>
                        )}
                    </Box>
                )}

                <Box
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 3fr) minmax(0, 1.2fr)" },
                        gap: 2,
                        alignItems: "start",
                    }}
                >
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <SecaoCard icone={<BusinessIcon />} titulo="Prestador" descricao="Dados da sua empresa, preenchidos automaticamente">
                            <Box sx={linhaCamposSx("1fr 1fr")}>
                                <TextField size='small' label="CPF ou CNPJ" disabled required value={MascaraCnpj(user?.empresa?.cnpj || "")} variant="outlined" fullWidth sx={campoSx} />
                                <TextField size='small' label="Razão Social" disabled required value={user?.empresa?.razaoSocial || ""} variant="outlined" fullWidth sx={campoSx} />
                            </Box>
                        </SecaoCard>

                        <SecaoCard
                            icone={<PersonOutlineIcon />}
                            titulo="Tomador"
                            descricao="Quem recebeu o serviço (paciente, clínica ou hospital)"
                            acao={
                                <FormControlLabel
                                    control={<Checkbox size="small" checked={hasTomador} onChange={(e) => setHasTomador(e.target.checked)} sx={{ "&.Mui-checked": { color: "#0b243d" } }} />}
                                    label="Nota possui tomador?"
                                    sx={{ mr: 0, "& .MuiFormControlLabel-label": { fontSize: 13, color: "#374151" } }}
                                />
                            }
                        >
                            {hasTomador ? (
                                <>
                                    <Box sx={linhaCamposSx("1fr 1fr")}>
                                        <TextField size='small' label="CPF ou CNPJ" required value={cpfCnpjTomador} onChange={(e) => handleCpfCnpjTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} helperText="Com CNPJ completo, os dados são preenchidos automaticamente" />
                                        <TextField size='small' label="Razão Social ou Nome" required value={razaoSocialTomador} onChange={(e) => setRazaoSocialTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                    <Box sx={linhaCamposSx("1fr 1fr")}>
                                        <TextField size='small' label="E-mail" type="email" value={emailTomador} onChange={(e) => setEmailTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size='small' label="Telefone" type="tel" value={telefoneTomador} onChange={(e) => setTelefoneTomador(MascaraTelefone(e.target.value))} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                    <Box sx={linhaCamposSx("1fr 2fr 0.6fr")}>
                                        <TextField size='small' label="CEP" value={cepTomador} onChange={(e) => handleCepTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} helperText={cepTomador && !codigoIbgeTomador ? "Município não identificado pelo CEP" : ""} />
                                        <TextField size='small' label="Endereço" value={enderecoTomador} onChange={(e) => setEnderecoTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size='small' label="Nº" value={numeroTomador} onChange={(e) => setNumeroTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                    <Box sx={linhaCamposSx("1fr 1fr 1fr")}>
                                        <FormControl fullWidth size='small' sx={campoSx}>
                                            <InputLabel id="estado-tomador-select-label">Estado</InputLabel>
                                            <Select
                                                labelId="estado-tomador-select-label"
                                                id="estado-tomador-select"
                                                value={estadoTomador}
                                                label="Estado"
                                                onChange={handleChange}
                                            >
                                                {estados.map((uf) => (
                                                    <MenuItem key={uf} value={uf}>{uf}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <TextField size='small' label="Cidade" value={cidadeTomador} onChange={(e) => setCidadeTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size='small' label="Bairro" value={bairroTomador} onChange={(e) => setBairroTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                </>
                            ) : (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, backgroundColor: "#fef3c7", color: "#b45309", borderRadius: "8px", px: 1.5, py: 1 }}>
                                    <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                                    <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Nota fiscal de serviço sem tomador.</Typography>
                                </Box>
                            )}
                        </SecaoCard>

                        <SecaoCard
                            icone={<MedicalServicesOutlinedIcon />}
                            titulo="Serviço"
                            descricao="Serviço prestado e valores"
                            acao={
                                <Button
                                    size="small"
                                    onClick={() => navigate("../Dashboard/Servicos")}
                                    sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, color: "#1976d2", px: 0.5, "&:hover": { backgroundColor: "transparent", textDecoration: "underline" } }}
                                >
                                    Meus serviços
                                </Button>
                            }
                        >
                            <Autocomplete
                                size="small"
                                fullWidth
                                disablePortal
                                options={servicos}
                                getOptionLabel={(option) =>
                                    `${option.codigo} - ${option.cnae ? option.cnae : 'N/A'} - ${option.discriminacao}`
                                }
                                value={servicoSelecionado}
                                onChange={(event, newValue) => {
                                    setServicoSelecionado(newValue);
                                    setDescricaoServico(newValue?.discriminacao || '');
                                }}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            paddingY: 0.5,
                                        }}
                                    >
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            codigo: {option.codigo} cnae: {option.cnae ? option.cnae : 'N/A'} nbs: {option.codigoNbs ? option.codigoNbs : 'não cadastrado'}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {option.discriminacao}
                                        </Typography>
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} label="Selecione o serviço" placeholder='Selecione o serviço que foi prestado' variant="outlined" sx={campoSx} />
                                )}
                            />
                            {servicoSemNbs && (
                                <Box sx={{ display: "flex", alignItems: { xs: "stretch", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, justifyContent: "space-between", gap: 1, backgroundColor: "#fee2e2", color: "#b91c1c", borderRadius: "8px", px: 1.5, py: 1 }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <WarningAmberIcon sx={{ fontSize: 18 }} />
                                        <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
                                            Este serviço não tem código NBS, obrigatório no Emissor Nacional. Cadastre o NBS antes de emitir.
                                        </Typography>
                                    </Box>
                                    <Button size="small" onClick={() => navigate("../Dashboard/Servicos")} sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, color: "#b91c1c", whiteSpace: "nowrap" }}>
                                        Editar serviço
                                    </Button>
                                </Box>
                            )}
                            <TextField size="small" label="Descrição do Serviço" required multiline minRows={2} value={descricaoServico} onChange={e => setDescricaoServico(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                            <Box sx={linhaCamposSx("1fr 1fr")}>
                                <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} size='small' label="Valor do Serviço" value={valorServico} onChange={e => setValorServico(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                <TextField size="small" label="Alíquota Simples Nacional / Mês (%)" value={aliquota} onChange={e => setAliquota(e.target.value.replace(/[^0-9,]/g, ''))} variant="outlined" fullWidth sx={campoSx} helperText="Alíquota efetiva do DAS (tributos aproximados)" />
                            </Box>

                            <Button
                                size="small"
                                startIcon={mostrarAvancadas ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                onClick={() => setMostrarAvancadas(!mostrarAvancadas)}
                                sx={{ alignSelf: "flex-start", textTransform: "none", fontSize: 13, fontWeight: 600, color: "#1976d2", px: 0.5, "&:hover": { backgroundColor: "transparent", textDecoration: "underline" } }}
                            >
                                {mostrarAvancadas ? "Ocultar configurações avançadas" : "Mostrar configurações avançadas"}
                            </Button>

                            <Collapse in={mostrarAvancadas} unmountOnExit>
                                <Box sx={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
                                    <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>Informações da Nota</Typography>
                                    <Box sx={linhaCamposSx("1fr 1fr 1fr")}>
                                        <TextField size="small" type="date" label="Data de Competência" value={dataCompetencia} onChange={e => setDataCompetencia(e.target.value)} InputLabelProps={{ shrink: true }} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size="small" label="Base de Cálculo (R$)" disabled value={moeda(valorBruto)} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size="small" label="Valor Líquido (R$)" disabled value={moeda(valorLiquido)} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                </Box>
                                <Box sx={{ mt: 1 }}>
                                    <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>Retenções</Typography>
                                    <Divider sx={{ mt: 1, mb: 1.5 }} />
                                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(auto-fill, minmax(220px, 1fr))" }, gap: 1.5 }}>
                                        <Box sx={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <Box>
                                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#374151" }}>Reter IR</Typography>
                                                    <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Imposto de Renda retido na fonte</Typography>
                                                </Box>
                                                <Switch size="small" checked={reterIr} onChange={e => { setReterIr(e.target.checked); setValorIrRetido(''); }} />
                                            </Box>
                                            <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} disabled={!reterIr} size='small' placeholder="Valor retido" value={valorIrRetido} onChange={e => setValorIrRetido(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Collapse>

                        </SecaoCard>
                    </Box>

                    {/* Resumo da nota */}
                    <Box sx={{ position: { md: "sticky" }, top: { md: 80 }, display: "flex", flexDirection: "column", gap: 2 }}>
                        <Box sx={{ ...cardSx, backgroundColor: "#0b243d", border: "none", color: "#fff" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                <Chip
                                    label="Resumo da nota"
                                    size="small"
                                    sx={{ backgroundColor: "rgba(255, 200, 69, 0.15)", color: "#ffc845", fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.6, textTransform: "uppercase" }}
                                />
                                <ReceiptLongOutlinedIcon sx={{ fontSize: 20, color: "#94a3b8" }} />
                            </Box>

                            <Box sx={{ mt: 2, backgroundColor: "rgba(255, 255, 255, 0.06)", borderRadius: "10px", p: 1.5 }}>
                                <Typography sx={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Tomador</Typography>
                                <Typography noWrap sx={{ mt: 0.25, fontSize: 14, fontWeight: 700 }}>
                                    {hasTomador ? (razaoSocialTomador || "Não informado") : "Sem tomador"}
                                </Typography>
                                {hasTomador && cpfCnpjTomador && (
                                    <Typography sx={{ fontSize: 11, color: "#94a3b8" }}>{cpfCnpjTomador}</Typography>
                                )}
                                <Typography sx={{ mt: 1.5, fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Serviço</Typography>
                                <Typography sx={{ mt: 0.25, fontSize: 13, fontWeight: 600, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                                    {servicoSelecionado ? servicoSelecionado.discriminacao : "Nenhum serviço selecionado"}
                                </Typography>
                            </Box>

                            <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 1 }}>
                                <LinhaResumo label="Valor do serviço" valor={moeda(valorBruto)} />
                                {reterIr && <LinhaResumo label="IR retido" valor={`- ${moeda(valorIr)}`} />}
                                <Box sx={{ borderTop: "1px solid rgba(255, 255, 255, 0.1)", my: 0.5 }} />
                                <LinhaResumo label="Valor líquido" valor={moeda(valorLiquido)} destaque />
                            </Box>

                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={<ReceiptLongOutlinedIcon />}
                                onClick={handleEmitirNota}
                                disabled={emitindo || !!bloqueio || servicoSemNbs}
                                sx={{
                                    mt: 2.5,
                                    py: 1.25,
                                    textTransform: "none",
                                    fontSize: 14,
                                    fontWeight: 700,
                                    color: "#111827",
                                    backgroundColor: "#ffc845",
                                    borderRadius: "8px",
                                    boxShadow: "none",
                                    "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" },
                                }}
                            >
                                {emitindo ? "Enviando..." : "Emitir nota fiscal"}
                            </Button>
                        </Box>

                        <Box sx={{ ...cardSx, display: "flex", gap: 1.5, p: 2 }}>
                            <InfoOutlinedIcon sx={{ fontSize: 18, color: "#6b7280", mt: 0.25 }} />
                            <Typography sx={{ fontSize: 12, color: "#4b5563" }}>
                                A nota é enviada para a prefeitura e o status (emitida ou rejeitada) aparece em <Link underline="hover" sx={{ cursor: "pointer", fontWeight: 600, color: "#111827" }} onClick={() => navigate("../Dashboard/NotasFiscaisEmitidas")}>Notas fiscais emitidas</Link>.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Loading open={open} setOpen={setOpen} />
            <AlertError openSnackbarError={openSnackbarError} setOpenSnackbarError={setOpenSnackbarError} mensagem={mensagem} />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
        </>
    )
}


export default EmitirNotaServico;
